import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { Stack } from '@cp/ds/src/components/stack';
import { CheckmarkIcon } from '@cp/ds/src/icons/checkmark';
import { useTheme } from '@cp/ds/src/hooks';
import { RepliedProps } from './model';

const ICON_SIZE = 16;

export const Replied: React.FC<RepliedProps> = () => {
  const theme = useTheme();

  return (
    <Stack alignItems="center" direction="row">
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ width: ICON_SIZE, height: ICON_SIZE, borderRadius: '50%', backgroundColor: 'green', mr: 0.75 }}
      >
        <CheckmarkIcon fontSize="1rem" sx={{ color: theme.palette.white }} />
      </Stack>
      <Typography sx={{ color: 'gray dark' }} variant="small text">
        Вы уже откликнулись
      </Typography>
    </Stack>
  );
};
